import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fb-analitics-grid mt-3"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" Комментарии "),
  /*#__PURE__*/_createElementVNode("span", null, "Смотреть все")
], -1)
const _hoisted_3 = { class: "subtitle" }
const _hoisted_4 = { class: "fb-analitics__comment mt-4" }
const _hoisted_5 = { class: "comment__title" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "comment__text" }
const _hoisted_8 = { class: "comment__sub" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "small" }, "Отзыв по", -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "team-info-drawer__header mb-5" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Комментарии", -1)
const _hoisted_13 = { class: "small ml-3 mt-1" }
const _hoisted_14 = { class: "fb-analitics__comment mb-4 mx-5" }
const _hoisted_15 = { class: "comment__title" }
const _hoisted_16 = { class: "name" }
const _hoisted_17 = { class: "comment__text" }
const _hoisted_18 = { class: "comment__sub" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "small" }, "Отзыв по", -1)

import { feedbackApi } from '@/api/feedback';
import { useProgramsStore } from '@/stores/programs';
import { num } from '@/utils/lang';
import { computed, ref, shallowReactive, watch } from 'vue';
import VBarChart from './VBarChart.vue';
import VStub from './VStub.vue';
import VTime from './VTime.vue';
import VUserInfo from './VUserInfo.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackGrid',
  props: {
    programId: null,
    trackerId: null
  },
  setup(__props: any) {

const props = __props as { programId: string, trackerId?: string }


const statsData = shallowReactive<{ [ programId: string ]: any[] }>({})

const drawerOpened = ref(false)

const stats = computed<{ 
  stats: { [key: string]: any }, 
  comments: { teamId: string, trackerId: string, text: string, date: string }[],
  lastComment: { teamId: string, trackerId: string, text: string, date: string } | null
}>(() => {
  const stats = props.programId && statsData[props.programId]
  if (!stats) return { stats: {}, comments: [], lastComment: null }
  const comments = []
  const stat: any = {}

  for (let report of stats) {
    if (props.trackerId && props.trackerId !== "all" && report.trackerId !== props.trackerId) continue
    for (let field in report.fields) {
      if (field.startsWith("Комментарий")) {
        if (report.fields[field]) {
          comments.push({ teamId: report.teamId, trackerId: report.trackerId, text: report.fields[field], date: report.date })
        }
        continue
      }
      if (!stat[field]) stat[field] = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 }
      stat[field][report.fields[field]]++
    }
  }
  const lastComment = comments[0]
  return { stats: stat, comments, lastComment }
})

const programsStore = useProgramsStore()
const program = computed(() => {
  if (!props.programId) return null
  return programsStore.programs.find(item => item.id === props.programId)
})

const getTooltipStr= (value: number, count: number, index?: number) => {
  return `${num(value, 'человек', 'человека', 'человек')} (${Math.round(value/count*100)}%)`
}

watch(() => props.programId, async (programId) => {
  if (!programId) return
  if (!statsData[programId]) {
    const resp = await feedbackApi.getFeedbackData(programId, true)
    statsData[programId] = resp.items
  }
}, { immediate: true })


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ((_unref(stats).comments.length > 0))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stats).stats, (stat, title) => {
            return (_openBlock(), _createBlock(VBarChart, {
              data: stat,
              title: (title as string),
              tooltip: getTooltipStr
            }, null, 8, ["data", "title"]))
          }), 256)),
          ((_unref(stats).comments.length > 0))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fb-analitics__card",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (drawerOpened.value = true))
              }, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(num)(_unref(stats).comments.length, "ответ", "ответа", "ответов")), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(program)?.teams.find(item => item.id === _unref(stats).lastComment?.teamId )?.name), 1),
                    _createVNode(VTime, {
                      date: _unref(stats).lastComment?.date,
                      class: "ml-auto"
                    }, null, 8, ["date"])
                  ]),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(stats).lastComment?.text), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(VUserInfo, {
                      "user-id": _unref(stats).lastComment?.trackerId
                    }, null, 8, ["user-id"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(VStub, null, {
            default: _withCtx(() => [
              _createTextVNode("Отчетов с заданными параметрами пока ещё нет")
            ]),
            _: 1
          })
        ])),
    _createVNode(_component_v_navigation_drawer, {
      modelValue: drawerOpened.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((drawerOpened).value = $event)),
      temporary: "",
      location: "right",
      class: "team-info-drawer",
      width: "600",
      scrim: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(num)(_unref(stats).comments.length, "ответ", "ответа", "ответов")), 1),
          _createVNode(_component_v_btn, {
            icon: "mdi-close",
            variant: "flat",
            class: "ml-auto mr-n4",
            style: {"opacity":"0.6"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => ((drawerOpened.value = false)))
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stats).comments, (comment) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(program)?.teams.find(item => item.id === comment.teamId )?.name), 1),
              _createVNode(VTime, {
                date: comment.date,
                class: "ml-auto"
              }, null, 8, ["date"])
            ]),
            _createElementVNode("div", _hoisted_17, _toDisplayString(comment.text), 1),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(VUserInfo, {
                "user-id": comment.trackerId
              }, null, 8, ["user-id"])
            ])
          ]))
        }), 256))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})